import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { getSize, getColor, useQuestionDragAndDrop } from '@lib/common';
import { Popover } from 'antd';
import styled from 'styled-components';
import { ExclamationCircleFilled, HolderOutlined } from '@ant-design/icons';
import { memo, useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { formatContent } from '../utils';
import { applySidebarLiveDragToList, getSidebarLiveDragRowRole, useSidebarLiveDrag } from '../sidebar-live-drag.context';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ListRoot = styled.div.withConfig({
  displayName: "question-itemcomponent__ListRoot",
  componentId: "sc-1885s7k-0"
})(["display:flex;flex-direction:column;"]);
var QuestionWrapper = styled.div.withConfig({
  displayName: "question-itemcomponent__QuestionWrapper",
  componentId: "sc-1885s7k-1"
})(["position:relative;will-change:transform;"]);
var DragHandle = styled.div.withConfig({
  displayName: "question-itemcomponent__DragHandle",
  componentId: "sc-1885s7k-2"
})(["display:flex;align-items:center;justify-content:center;flex-shrink:0;width:28px;height:32px;margin-left:-2px;border-radius:6px;color:#64748b;cursor:grab;touch-action:none;.anticon{font-size:20px;}&:hover{color:#334155;background-color:#e2e8f0;}&:active{cursor:grabbing;color:#1e293b;background-color:#cbd5e1;}"]);
var QuestionWrapperHover = styled(QuestionWrapper).withConfig({
  displayName: "question-itemcomponent__QuestionWrapperHover",
  componentId: "sc-1885s7k-3"
})(["", " ", " &[data-active='true'] ", "{color:", ";}"], function (_ref) {
  var $isHeading = _ref.$isHeading;
  return !$isHeading ? "\n    margin-left: 16px;\n  " : "\n    margin-left: 0;\n  ";
}, function (_ref2) {
  var $rowRole = _ref2.$rowRole;
  return $rowRole === 'ghost' ? "\n    opacity: 0.45;\n    /* Keep pointer events \u2014 users release on the ghost; disabling them\n       makes HTML5 miss the drop target and never commit the move. */\n  " : '';
}, DragHandle, getColor('fillIntActive'));
var QuestionItemContainer = styled.div.withConfig({
  displayName: "question-itemcomponent__QuestionItemContainer",
  componentId: "sc-1885s7k-4"
})(["display:flex;align-items:flex-start;gap:", ";padding:", ";", " cursor:pointer;min-height:", ";margin-top:", ";border-radius:", ";border:1px ", " ", ";border-left:2px ", " ", ";background-color:", ";opacity:", ";transition:border-color 0.15s ease,background-color 0.15s ease,opacity 0.15s ease;&:hover{border-left-color:", ";background-color:", ";.question-summary-text{color:", ";}}"], getSize('padding8'), getSize('padding8'), function (_ref3) {
  var $isHeading = _ref3.$isHeading;
  return $isHeading ? "\n    padding-left: 4px;\n  " : '';
}, function (_ref4) {
  var $isHeading = _ref4.$isHeading;
  return $isHeading ? '36px' : '44px';
}, getSize('padding4'), getSize('radiusSm'), function (_ref5) {
  var $isDragging = _ref5.$isDragging;
  return $isDragging ? 'dashed' : 'solid';
}, function (_ref6) {
  var $isDragging = _ref6.$isDragging;
  return $isDragging ? '#94a3b8' : 'transparent';
}, function (_ref7) {
  var $isDragging = _ref7.$isDragging;
  return $isDragging ? 'dashed' : 'solid';
}, function (_ref8) {
  var $active = _ref8.$active,
      $isDragging = _ref8.$isDragging;
  return $isDragging ? '#94a3b8' : $active ? getColor('fillIntActive') : 'transparent';
}, function (_ref9) {
  var $active = _ref9.$active,
      $isDragging = _ref9.$isDragging;
  return $isDragging ? '#f1f5f9' : $active ? '#f0f7ff' : 'transparent';
}, function (_ref10) {
  var $isDragging = _ref10.$isDragging;
  return $isDragging ? 0.35 : 1;
}, function (_ref11) {
  var $isDragging = _ref11.$isDragging;
  return $isDragging ? '#94a3b8' : getColor('fillIntActive');
}, function (_ref12) {
  var $active = _ref12.$active,
      $isDragging = _ref12.$isDragging;
  return $isDragging ? '#f1f5f9' : $active ? '#f0f7ff' : '#f8fafc';
}, getColor('fillIntActive'));
var DragHandleSpacer = styled.div.withConfig({
  displayName: "question-itemcomponent__DragHandleSpacer",
  componentId: "sc-1885s7k-5"
})(["flex-shrink:0;width:28px;height:32px;margin-left:-2px;"]);
var StyledQuestionIndex = styled.span.withConfig({
  displayName: "question-itemcomponent__StyledQuestionIndex",
  componentId: "sc-1885s7k-6"
})(["font-weight:600;font-size:", ";line-height:1.4;color:", ";min-width:24px;flex-shrink:0;"], getSize('typo14'), getColor('contentTitle'));
var QuestionMainContent = styled.div.withConfig({
  displayName: "question-itemcomponent__QuestionMainContent",
  componentId: "sc-1885s7k-7"
})(["display:flex;align-items:baseline;gap:", ";flex:1;min-width:0;padding-top:6px;"], getSize('padding8'));
var StyledQuestionText = styled.div.withConfig({
  displayName: "question-itemcomponent__StyledQuestionText",
  componentId: "sc-1885s7k-8"
})(["flex:1;min-width:0;font-size:", ";color:", ";overflow:hidden;"], getSize('typo14'), getColor('contentTitle'));
var QuestionDescriptionValue = styled.span.withConfig({
  displayName: "question-itemcomponent__QuestionDescriptionValue",
  componentId: "sc-1885s7k-9"
})(["display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden;text-overflow:ellipsis;width:100%;line-height:1.4;color:", ";font-weight:", ";"], getColor('contentTitle'), function (_ref13) {
  var $type = _ref13.$type;
  return $type === 'heading' ? 'bold' : 'normal';
});
var StyledExclamationCircleFilled = styled(ExclamationCircleFilled).withConfig({
  displayName: "question-itemcomponent__StyledExclamationCircleFilled",
  componentId: "sc-1885s7k-10"
})(["color:", ";margin-right:", ";"], getColor('fillHighlight1'), getSize('padding12'));
var StyledPointText = styled.span.withConfig({
  displayName: "question-itemcomponent__StyledPointText",
  componentId: "sc-1885s7k-11"
})(["font-size:", ";font-weight:600;color:#94a2b8;padding-top:6px;"], getSize('typo12'));
var QuestionItem = /*#__PURE__*/memo(function (_ref14) {
  var question = _ref14.question,
      isActive = _ref14.isActive,
      hasUnsavedQuestionOrSectionChanges = _ref14.hasUnsavedQuestionOrSectionChanges,
      onSelectQuestion = _ref14.onSelectQuestion,
      labelTranslation = _ref14.labelTranslation,
      moveQuestion = _ref14.moveQuestion,
      onDragEnd = _ref14.onDragEnd,
      onCrossSectionDrop = _ref14.onCrossSectionDrop,
      onCrossSectionHover = _ref14.onCrossSectionHover,
      onDragBegin = _ref14.onDragBegin,
      index = _ref14.index,
      sectionId = _ref14.sectionId,
      isDragPreview = _ref14.isDragPreview,
      _ref14$rowRole = _ref14.rowRole,
      rowRole = _ref14$rowRole === void 0 ? 'normal' : _ref14$rowRole;
  var isHeading = question.type === 'heading';
  var isGhost = rowRole === 'ghost';
  var canDrag = !hasUnsavedQuestionOrSectionChanges && !isGhost;
  var previewTitle = useMemo(function () {
    if (isHeading) {
      var headingTitle = question.title;
      return formatContent(headingTitle || question.description) || 'Heading';
    }

    return formatContent(question.description);
  }, [isHeading, question]);

  var _useQuestionDragAndDr = useQuestionDragAndDrop({
    targetItem: question,
    index: index,
    moveQuestion: moveQuestion,
    onDragEnd: onDragEnd,
    // Ghost must still accept the drop — users release on the preview row.
    onCrossSectionDrop: onCrossSectionDrop,
    onCrossSectionHover: isGhost ? undefined : onCrossSectionHover,
    onDragBegin: isGhost ? undefined : onDragBegin,
    title: previewTitle,
    canDrag: canDrag,
    liveReorder: true,
    sectionId: sectionId,
    acceptCrossSection: true,
    itemKind: isHeading ? 'heading' : 'question'
  }),
      dropRef = _useQuestionDragAndDr.dropRef,
      dragRef = _useQuestionDragAndDr.dragRef,
      isDragging = _useQuestionDragAndDr.isDragging;

  var showAsDragging = isDragging || Boolean(isDragPreview) || isGhost;

  var content = /*#__PURE__*/_jsxs(QuestionItemContainer, {
    $active: isActive,
    $isDragging: showAsDragging,
    $isHeading: isHeading,
    onClick: hasUnsavedQuestionOrSectionChanges ? undefined : function () {
      return onSelectQuestion(question);
    },
    children: [canDrag ? /*#__PURE__*/_jsx(DragHandle, {
      ref: dragRef,
      role: "button",
      tabIndex: 0,
      "aria-label": "Drag to reorder",
      title: "Drag to reorder",
      onClick: function onClick(event) {
        return event.stopPropagation();
      },
      onMouseDown: function onMouseDown(event) {
        return event.stopPropagation();
      },
      children: /*#__PURE__*/_jsx(HolderOutlined, {})
    }) : /*#__PURE__*/_jsx(DragHandleSpacer, {
      "aria-hidden": true
    }), /*#__PURE__*/_jsxs(QuestionMainContent, {
      children: [question.titleIndex && /*#__PURE__*/_jsxs(StyledQuestionIndex, {
        children: [question.titleIndex, "."]
      }), /*#__PURE__*/_jsx(StyledQuestionText, {
        children: /*#__PURE__*/_jsx(QuestionDescriptionValue, {
          className: "question-summary-text",
          $type: question.type,
          children: previewTitle
        })
      })]
    }), question.score ? /*#__PURE__*/_jsxs(StyledPointText, {
      children: [question.score, question.score > 1 ? labelTranslation.pointsShort : labelTranslation.pointShort]
    }) : null]
  });

  return /*#__PURE__*/_jsx(QuestionWrapperHover, {
    ref: dropRef,
    "data-id": question.id.toString(),
    "data-active": isActive ? 'true' : 'false',
    $isDragging: showAsDragging,
    $isHeading: isHeading,
    $rowRole: rowRole,
    children: hasUnsavedQuestionOrSectionChanges ? /*#__PURE__*/_jsx(Popover, {
      title: "",
      content: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(StyledExclamationCircleFilled, {}), /*#__PURE__*/_jsx("span", {
          children: labelTranslation.questionChangingWarning
        })]
      }),
      trigger: "hover",
      children: content
    }) : content
  });
});
QuestionItem.displayName = 'QuestionItem';

var getQuestionIdsKey = function getQuestionIdsKey(questions) {
  return questions.map(function (question) {
    return question.id.toString();
  }).join('|');
};

export var QuestionItemComponent = /*#__PURE__*/memo(function (_ref15) {
  var questions = _ref15.questions,
      hasUnsavedQuestionOrSectionChanges = _ref15.hasUnsavedQuestionOrSectionChanges,
      onSelectQuestion = _ref15.onSelectQuestion,
      labelTranslation = _ref15.labelTranslation,
      selectedFormItemId = _ref15.selectedFormItemId,
      sectionId = _ref15.sectionId,
      onMoveQuestion = _ref15.onMoveQuestion,
      onMoveQuestionToSection = _ref15.onMoveQuestionToSection;

  var _useSidebarLiveDrag = useSidebarLiveDrag(),
      liveDrag = _useSidebarLiveDrag.liveDrag,
      beginLiveDrag = _useSidebarLiveDrag.beginLiveDrag,
      previewInSection = _useSidebarLiveDrag.previewInSection,
      settleLiveDrag = _useSidebarLiveDrag.settleLiveDrag,
      endLiveDrag = _useSidebarLiveDrag.endLiveDrag,
      resolveItem = _useSidebarLiveDrag.resolveItem,
      commitCrossSectionMove = _useSidebarLiveDrag.commitCrossSectionMove;

  var liveDragRef = useRef(liveDrag);
  liveDragRef.current = liveDrag;

  var _useState = useState(questions),
      orderedQuestions = _useState[0],
      setOrderedQuestions = _useState[1];

  var orderedQuestionsRef = useRef(orderedQuestions);
  var isDraggingRef = useRef(false);
  var listRef = useRef(null);
  var previousRectsRef = useRef(new Map());
  var propsOrderKey = getQuestionIdsKey(questions);
  orderedQuestionsRef.current = orderedQuestions;
  var displayQuestions = useMemo(function () {
    if (liveDrag) {
      return applySidebarLiveDragToList(sectionId, questions, liveDrag);
    } // Same-section heading drags (no live-drag context) use local order while dragging.


    if (isDraggingRef.current) {
      return orderedQuestions;
    }

    return questions;
  }, [liveDrag, orderedQuestions, questions, sectionId]); // Cross-section hover sets isDraggingRef on the *target* section, but drag-end only
  // runs on the source — so the target flag would stay true and freeze a stale
  // orderedQuestions (without the moved item) after liveDrag clears.

  useEffect(function () {
    if (liveDrag) {
      return;
    }

    isDraggingRef.current = false;
    setOrderedQuestions(questions);
  }, [liveDrag, questions, propsOrderKey]); // FLIP animation — skipped while dragging so transforms don't break hit-testing.
  // Cross-section live previews still shift siblings instantly (same as in-section DnD).

  useLayoutEffect(function () {
    var root = listRef.current;
    if (!root) return;
    var nodes = Array.from(root.querySelectorAll('[data-id]'));
    var skipFlip = isDraggingRef.current || Boolean(liveDrag);

    if (skipFlip) {
      nodes.forEach(function (node) {
        var id = node.dataset.id;
        if (!id) return;
        previousRectsRef.current.set(id, node.getBoundingClientRect());
        node.style.transition = '';
        node.style.transform = '';
      });
      return;
    }

    nodes.forEach(function (node) {
      var id = node.dataset.id;
      if (!id) return;
      var nextRect = node.getBoundingClientRect();
      var prevRect = previousRectsRef.current.get(id);

      if (prevRect) {
        var deltaY = prevRect.top - nextRect.top;

        if (Math.abs(deltaY) > 1) {
          node.style.transition = 'none';
          node.style.transform = "translateY(".concat(deltaY, "px)");
          void node.offsetHeight;
          node.style.transition = 'transform 180ms ease';
          node.style.transform = '';
        }
      }

      previousRectsRef.current.set(id, nextRect);
    });
  }, [displayQuestions, liveDrag]);
  var handleHoverReorder = useCallback(function (dragIndex, hoverIndex) {
    if (dragIndex === hoverIndex) return;
    isDraggingRef.current = true; // When live-drag context is active, keep preview index in sync (same or cross section).

    if (liveDragRef.current) {
      previewInSection(sectionId, hoverIndex);
      return;
    }

    setOrderedQuestions(function (prev) {
      if (dragIndex < 0 || hoverIndex < 0 || dragIndex >= prev.length || hoverIndex >= prev.length) {
        return prev;
      }

      if (!prev[dragIndex]) {
        return prev;
      }

      var next = _toConsumableArray(prev);

      var _next$splice = next.splice(dragIndex, 1),
          _next$splice2 = _slicedToArray(_next$splice, 1),
          removed = _next$splice2[0];

      next.splice(hoverIndex, 0, removed);
      return next;
    });
  }, [previewInSection, sectionId]);
  var handleDragBegin = useCallback(function (item) {
    var domainItem = resolveItem(item.id) || questions.find(function (question) {
      return question.id.toString() === item.id;
    });

    if (!domainItem) {
      return;
    }

    isDraggingRef.current = true;
    beginLiveDrag({
      itemId: item.id,
      originalSectionId: item.originalSectionId || sectionId,
      currentSectionId: sectionId,
      currentIndex: item.originalIndex,
      item: domainItem
    });
  }, [beginLiveDrag, questions, resolveItem, sectionId]);
  var handleCrossSectionHover = useCallback(function (_item, hoverIndex) {
    isDraggingRef.current = true;
    previewInSection(sectionId, hoverIndex);
  }, [previewInSection, sectionId]);
  var handleCrossSectionDrop = useCallback(function (item, hoverIndex) {
    var sourceSectionId = item.originalSectionId || '';

    if (!sourceSectionId || sourceSectionId === sectionId) {
      return {
        dropped: false
      };
    }

    var active = liveDragRef.current;
    var targetIndex = active && active.itemId === item.id && active.currentSectionId === sectionId ? active.currentIndex : hoverIndex; // Commit immediately on drop — do not wait for drag-end (HTML5 didDrop is flaky).

    commitCrossSectionMove({
      questionId: item.id,
      targetSectionId: sectionId,
      targetIndex: targetIndex,
      sourceSectionId: sourceSectionId
    });
    return {
      dropped: true,
      crossSection: true,
      targetSectionId: sectionId,
      targetIndex: targetIndex
    };
  }, [commitCrossSectionMove, sectionId]);
  var handleDragEnd = useCallback(function (item, dropResult, didDrop) {
    var active = liveDragRef.current;
    requestAnimationFrame(function () {
      isDraggingRef.current = false;
    });
    var crossedSections = Boolean(active) && active.itemId === item.id && active.currentSectionId !== active.originalSectionId; // Cross-section: drop targets usually already committed. Fallback if needed.

    if (crossedSections && onMoveQuestionToSection) {
      if (didDrop || dropResult !== null && dropResult !== void 0 && dropResult.crossSection || active.phase === 'settled') {
        commitCrossSectionMove({
          questionId: active.itemId,
          targetSectionId: active.currentSectionId,
          targetIndex: active.currentIndex,
          sourceSectionId: active.originalSectionId
        });
        return;
      }

      endLiveDrag();
      setOrderedQuestions(questions);
      return;
    }

    if (dropResult !== null && dropResult !== void 0 && dropResult.crossSection) {
      settleLiveDrag();
      return;
    }

    var from = item.originalIndex;
    var to = active && active.itemId === item.id && active.currentSectionId === sectionId ? active.currentIndex : orderedQuestionsRef.current.findIndex(function (question) {
      return question.id.toString() === item.id;
    });

    if (from === to || to < 0) {
      endLiveDrag();
      setOrderedQuestions(questions);
      return;
    }

    settleLiveDrag();
    onMoveQuestion(from, to, sectionId);
  }, [commitCrossSectionMove, endLiveDrag, onMoveQuestion, onMoveQuestionToSection, questions, sectionId, settleLiveDrag]);
  return /*#__PURE__*/_jsx(ListRoot, {
    ref: listRef,
    children: displayQuestions.map(function (question, index) {
      var questionId = question.id.toString();
      var rowRole = getSidebarLiveDragRowRole(sectionId, questionId, liveDrag);
      var isDragPreview = (liveDrag === null || liveDrag === void 0 ? void 0 : liveDrag.phase) === 'dragging' && (rowRole !== 'normal' || liveDrag.itemId === questionId);
      return /*#__PURE__*/_jsx(QuestionItem, {
        question: question,
        isActive: selectedFormItemId === questionId && rowRole === 'normal',
        hasUnsavedQuestionOrSectionChanges: Boolean(hasUnsavedQuestionOrSectionChanges),
        onSelectQuestion: onSelectQuestion,
        labelTranslation: labelTranslation,
        moveQuestion: handleHoverReorder,
        onDragEnd: handleDragEnd,
        onCrossSectionDrop: onMoveQuestionToSection ? handleCrossSectionDrop : undefined,
        onCrossSectionHover: onMoveQuestionToSection ? handleCrossSectionHover : undefined,
        onDragBegin: onMoveQuestionToSection ? handleDragBegin : undefined,
        index: index,
        sectionId: sectionId,
        isDragPreview: isDragPreview,
        rowRole: rowRole
      }, rowRole === 'ghost' ? "".concat(questionId, "-ghost") : questionId);
    })
  });
});
QuestionItemComponent.displayName = 'QuestionItemComponent';